import { render, staticRenderFns } from "./cookie-box.vue?vue&type=template&id=e213719e&scoped=true"
import script from "./cookie-box.vue?vue&type=script&lang=js"
export * from "./cookie-box.vue?vue&type=script&lang=js"
import style0 from "./cookie-box.vue?vue&type=style&index=0&id=e213719e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e213719e",
  null
  
)

export default component.exports